import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { DBDateField, DBRadioButton, DBTextArea, DBTextField } from '_components';
import styles from './PrevTher.module.css';
import { PatientCareCenterNoteNavAnchor } from '../NavAnchor';


class PatientCareCenterNoteSubjectivePrevTher extends React.Component {

    handlePrevTherClick(selectedVal) {
        if (selectedVal === undefined || selectedVal === false) {
            this.props.clearFields(this.props.noteId, 'PTEVAL', 'EVNO', this.props.evno, ['EVSUBPREVSUCCESS', 'EVSUBPREVDCDATE', 'EVSUBPREVLOCATION', 'EVSUBPREVDESC']);
        }
    }

    render() {
        return (
            <PatientCareCenterNoteNavAnchor id='subj_prev_ther'>
                <div id='subj_prev_ther'>
                    {!this.props.isPeds ? (<div className={styles.row}>
                        <label className={styles.col1_wide}>Previous therapy for same condition?</label>
                        <DBRadioButton
                            noteId={this.props.noteId}
                            entity='PTEVAL'
                            entityKeyColumn='EVNO'
                            entityKeyValue={this.props.evno}
                            field='EVSUBPREVSAME'
                            className={styles.col2}
                            selectedValue={true}
                            label='Yes'
                            onClick={(selectedVal) => this.handlePrevTherClick(selectedVal)}
                        />
                        <DBRadioButton
                            noteId={this.props.noteId}
                            entity='PTEVAL'
                            entityKeyColumn='EVNO'
                            entityKeyValue={this.props.evno}
                            field='EVSUBPREVSAME'
                            className={styles.col3}
                            selectedValue={false}
                            label='No'
                            onClick={(selectedVal) => this.handlePrevTherClick(selectedVal)}
                        />
                    </div>) : null}
                    

                    {this.props.prevTher &&
                        <div>
                            <div className={styles.row}>
                                <label className={styles.col1_wide}>Was previous therapy successful?</label>
                                <DBRadioButton
                                    noteId={this.props.noteId}
                                    entity='PTEVAL'
                                    entityKeyColumn='EVNO'
                                    entityKeyValue={this.props.evno}
                                    field='EVSUBPREVSUCCESS'
                                    className={styles.col2}
                                    selectedValue={true}
                                    label='Yes'
                                />
                                <DBRadioButton
                                    noteId={this.props.noteId}
                                    entity='PTEVAL'
                                    entityKeyColumn='EVNO'
                                    entityKeyValue={this.props.evno}
                                    field='EVSUBPREVSUCCESS'
                                    className={styles.col3}
                                    selectedValue={false}
                                    label='No'
                                />
                            </div>

                            <div className={styles.row}>
                                <div className={styles.col1_top}>Discharge Date:</div>
                                <DBDateField
                                    noteId={this.props.noteId}
                                    entity='PTEVAL'
                                    entityKeyColumn='EVNO'
                                    maxDate={new Date()}
                                    entityKeyValue={this.props.evno}
                                    field='EVSUBPREVDCDATE'
                                />
                            </div>

                            <div className={styles.row}>
                                <div className={styles.col1_top}>Location:</div>
                                <DBTextField
                                    noteId={this.props.noteId}
                                    entity='PTEVAL'
                                    entityKeyColumn='EVNO'
                                    entityKeyValue={this.props.evno}
                                    field='EVSUBPREVLOCATION'
                                    className={styles.textarea}
                                />
                            </div>

                            <div className={styles.row}>
                                <div className={styles.col1_top}>Description:</div>
                                <DBTextArea
                                    noteId={this.props.noteId}
                                    entity='PTEVAL'
                                    entityKeyColumn='EVNO'
                                    entityKeyValue={this.props.evno}
                                    field='EVSUBPREVDESC'
                                    className={styles.textarea}
                                />
                            </div>
                        </div>
                    }

                </div>
            </PatientCareCenterNoteNavAnchor>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        clearFields: bindActionCreators(noteActions.clearFields, dispatch)
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let evno = parseInt(noteId.split("_")[1]);

    let isPeds = state.entities.admissions[state.entities.notes.PTEVAL[evno].EVEPNO].isPeds;
    let isPedsEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['SAPPHIRE_PEDS_ENABLED'].PRVALUE === 'true' : false;
    if (!isPedsEnabled) {
        isPeds = isPedsEnabled;
    }

    return {
        noteId: noteId,
        evno: evno,
        prevTher: state.entities.notes.PTEVAL[evno].EVSUBPREVSAME ? state.entities.notes.PTEVAL[evno].EVSUBPREVSAME : false,
        isPeds
    };
}

const connectedPatientCareCenterNoteSubjectivePrevTher = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteSubjectivePrevTher);
export { connectedPatientCareCenterNoteSubjectivePrevTher as PatientCareCenterNoteSubjectivePrevTher };

